const ProductCardSkeleton = () => {
  return (
    <div className="flex h-full flex-col gap-3 animate-pulse">
      <div className="w-full h-48 bg-grey rounded"></div>
      <div className="h-4 w-3/4 bg-grey rounded"></div>
      <div className="h-4 w-2/3 bg-grey rounded"></div>
      <div className="mt-auto">
        <div className="h-5 w-1/2 bg-grey rounded mb-2"></div>
        <div className="h-10 w-full bg-grey rounded"></div>
      </div>
    </div>
  );
};

const CategoryProductsGridSkeleton = ({ items = 6 }) => {
  return (
    <div
      id="products-list"
      className="grid grid-cols-2 md:grid-cols-3 py-4 gap-4 md:gap-6"
    >
      {Array.from({ length: items }).map((_, index) => (
        <div key={`product-card-skeleton-${index}`} className="col">
          <ProductCardSkeleton />
        </div>
      ))}
    </div>
  );
};

export default CategoryProductsGridSkeleton;
